import React from "react"

import { PageTop } from "../PageTop"

export const ToTopButton: React.FC = () => {
  return <PageTop displayOffset={3} />
}
